import { useState } from "react";
import imageCompression from "browser-image-compression";
import { useDispatch } from "react-redux";
import { uploadFile } from "react-s3";

const config = {
  bucketName: process.env.REACT_APP_AWS_STORAGE_BUCKET_NAME,
  dirName: "clients",
  region: process.env.REACT_APP_AWS_S3_REGION_NAME,
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
};

const useHandleImageUpload = () => {
  const [loadingImage, setLoadingImage] = useState(false);
  const [compressedImage, setCompressedImage] = useState();
  const [imageUrl, setImageUrl] = useState("");
  const dispatch = useDispatch();

  const handleCompress = async (imageObj) => {
    if (!imageObj) {
      return;
    }

    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };

    const processedImg = await imageCompression(imageObj, options);
    setCompressedImage(processedImg);
    return processedImg;
  };

  const cleanName = (name) => {
    const nameArr = name?.split("/");
    return nameArr[nameArr?.length - 1];
  };

  const handleImageChange = async (info, isChange, name) => {
    if (loadingImage) {
      return;
    }
    setLoadingImage(true);
    const compressed = await handleCompress(info?.file?.originFileObj);

    const url = await uploadFile(compressed, config)
      .then((data) => data?.location)
      .catch((err) =>
        dispatch(
          showAlertAction({
            message: err?.message,
            level: "danger",
            isVisible: true,
          })
        )
      );
    setLoadingImage(false);

    setImageUrl(url);
    return url
  };

  return {
    compressedImage,
    handleCompress,
    handleImageChange,
    compressedImage,
    loadingImage,
    imageUrl,
  };
};

export { useHandleImageUpload };
